/** "INTERNO": se ve en Winclap, no se comparte con el cliente ni el partner, el asistente no lo lee. */
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EnumBadge } from '@/components/ui/enum-badge';

export function InternalBadge({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={`inline-flex items-center gap-1 ${className ?? ''}`} title={t('partnerships.package_sheet.internal_hint')}>
      <Lock className="h-3 w-3 text-amber-700 dark:text-amber-400" />
      <EnumBadge value="internal" tone="warning" className="text-[10px] px-1.5 py-0" label={t('partnerships.package_sheet.internal_badge')} />
    </span>
  );
}
